import React, { useEffect, useState } from 'react';
import { calculateScale } from '../services/scaleBarService';

/**
 * スケールバーコンポーネント
 */
const ScaleBar = ({
  map,
  isFromKntr = false,
}) => {
  const [scaleInfo, setScaleInfo] = useState(null);

  useEffect(() => {
    if (!map) return;

    const updateScale = () => {
      const newScale = calculateScale(map);
      setScaleInfo(newScale);
    };

    map.once('load', updateScale);
    map.on('zoom', updateScale);
    map.on('move', updateScale);
    map.on('resize', updateScale);

    return () => {
      map.off('zoom', updateScale);
      map.off('move', updateScale);
      map.off('resize', updateScale);
    };
  }, [map]);

  // マップが初期化されていない場合は表示しない
  if (!map || !scaleInfo) {
    return null;
  }

  // kntrは別クラス
  const className = isFromKntr
    ? 'kntr-scale-bar'
    : 'scale-bar';

  return (
    <div className={className} id="scale-bar">
      <div className={`${className}-text`}>
        {scaleInfo.distance ?? ""}{scaleInfo.unit ?? ""}
      </div>
      <div
        className={`${className}-ruler`}
        style={{ width: `${scaleInfo.width ?? 0}px` }}
      />
    </div>
  );
};

export default ScaleBar;
